import IconButton from 'components/common/IconButton';
import PropTypes from 'prop-types';
import { default as React, useEffect, useState } from 'react';
import { Button, Col, Form, Modal, Row, Spinner, Table } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import 'react-loading-skeleton/dist/skeleton.css';
import FalconCloseButton from '../../components/common/FalconCloseButton';
import useToken from '../../hooks/useToken';
import { useToast } from 'context/providers/ToastProvider';
import CopyButton from '../servicio/CopyButton';

const SeccionConfiguracionDatosNube = ({
    idLicencia,
    licencias,
    getInformacionDetalladaLicenciaByID
}) => {

    const [datosNube, setDatosNube] = useState(null);
    const [procesandoModal, setProcesandoModal] = useState(false);
    const [editarIdentificador, setEditarIdentificador] = useState(false);
    const [editarUsuarioNube, setEditarUsuarioNube] = useState(false);
    const [editarContrasenaNube, setEditarContrasenaNube] = useState(false);
    const [editarServidorBD, setEditarServidorBD] = useState(false);
    const [BDServer, setBDServer] = useState([]);
    const { register, handleSubmit, formState: { errors } } = useForm();
    /**
    * AUTENTICACION
    */
    const { token, setToken, idCatTipoUsuario } = useToken();
    const { showErrorToast, showSuccessToast } = useToast();

    /**
  * Submit de identificador
  * @param {any} data
  */
    const onSubmitIdentificador = data => {
        setProcesandoModal(true);
        console.log(data);

        EditarIdentificadorDatosNube(data.idSyncCredenciales, JSON.stringify(data, null, 2));
    };

    /**
     * Submit de usuario nube
     * @param {any} data
     */
    const onSubmitUsuarioNube = data => {
        setProcesandoModal(true);
        console.log(data);

        EditarUsuarioNubeDatosNube(data.idSyncCredenciales, JSON.stringify(data, null, 2));
    };

    /**
     * Submit de contrase�a
     * @param {any} data
     */
    const onSubmitContrasenaNube = data => {
        setProcesandoModal(true);
        console.log(data);

        EditarContrasenaNubeDatosNube(data.idSyncCredenciales, JSON.stringify(data, null, 2));
    };

    /**
     * Submit de servidor 
     * @param {any} data
     */
    const onSubmitServidorBD = data => {
        setProcesandoModal(true);
        console.log(data);

        EditarServidorBDDatosNube(data.idSyncCredenciales, JSON.stringify(data, null, 2));
    };


    /**
   * Edita identificador de datos de la nube
   * @param {any} key
   * @param {any} values
   */
    const EditarIdentificadorDatosNube = async (key, values) => {
        console.log(values);
        const response = await fetch("/api/licencia/EditarIdentificadorDatosNube/?key=" + key + "&values=" + encodeURIComponent(values), {
            method: 'PUT',
            headers:
            {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        })
            .catch((error) => {
                showErrorToast('Hubo un problema con la peticion Fetch:' + error);
                console.log('Hubo un problema con la peticion Fetch:' + error);

            });

        if (response.ok) {

            //console.log(response);
            const data = await response.json();
            console.log(data);

            if (data.iResponseType == 1) {

                showSuccessToast(data.vMessage);

                getInformacionDetalladaLicenciaByID();
            }
            else {
                showErrorToast(data.vMessage);
            }

        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            console.log(response);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
        setEditarIdentificador(false);
        setProcesandoModal(false);

    };

    /**
     * Edita datos de un usuario de la nube
     * @param {any} key
     * @param {any} values
     */
    const EditarUsuarioNubeDatosNube = async (key, values) => {
        console.log(values);
        const response = await fetch("/api/licencia/EditarUsuarioNubeDatosNube/?key=" + key + "&values=" + encodeURIComponent(values), {
            method: 'PUT',
            headers:
            {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        })
            .catch((error) => {
                showErrorToast('Hubo un problema con la peticion Fetch:' + error);
                console.log('Hubo un problema con la peticion Fetch:' + error);

            });

        if (response.ok) {

            //console.log(response);
            const data = await response.json();
            console.log(data);

            if (data.iResponseType == 1) {

                showSuccessToast(data.vMessage);
                getInformacionDetalladaLicenciaByID();
            }
            else {
                showErrorToast(data.vMessage);
            }


        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            console.log(response);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
        setEditarUsuarioNube(false);
        setProcesandoModal(false);
    };

    /**
     * Edita la contrase�a de la nube
     * @param {any} key
     * @param {any} values
     */
    const EditarContrasenaNubeDatosNube = async (key, values) => {
        console.log(values);
        const response = await fetch("/api/licencia/EditarContrasenaNubeDatosNube/?key=" + key + "&values=" + encodeURIComponent(values), {
            method: 'PUT',
            headers:
            {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        })
            .catch((error) => {
                showErrorToast('Hubo un problema con la peticion Fetch:' + error);
                console.log('Hubo un problema con la peticion Fetch:' + error);
            });

        if (response.ok) {

            //console.log(response);
            const data = await response.json();
            console.log(data);

            if (data.iResponseType == 1) {

                showSuccessToast(data.vMessage);
                getInformacionDetalladaLicenciaByID();
            }
            else {
                showErrorToast(data.vMessage);
            }


        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            console.log(response);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
        setEditarContrasenaNube(false);
        setProcesandoModal(false);
    };

    /**
     * Edita servidor
     * @param {any} key
     * @param {any} values
     */
    const EditarServidorBDDatosNube = async (key, values) => {
        console.log(values);
        const response = await fetch("/api/licencia/EditarServidorBDDatosNube/?key=" + key + "&values=" + encodeURIComponent(values), {
            method: 'PUT',
            headers:
            {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        })
            .catch((error) => {
                showErrorToast('Hubo un problema con la peticion Fetch:' + error);
                console.log('Hubo un problema con la peticion Fetch:' + error);
            });

        if (response.ok) {

            //console.log(response);
            const data = await response.json();
            //console.log(data);

            if (data.iResponseType == 1) {

                showSuccessToast(data.vMessage);
                getInformacionDetalladaLicenciaByID();
            }
            else {
                showErrorToast(data.vMessage);
            }
        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            console.log(response);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
        setEditarServidorBD(false);
        setProcesandoModal(false);
    };

    /**
  * Obtiene detalles
  */
    const ObtenerListaServidores = async () => {

        const response = await fetch("/api/licencia/ObtenerListaServidores", {
            method: 'GET',
            headers:
            {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        })
            .catch((error) => {
                showErrorToast('' + error.message);
                console.log('Hubo un problema con la peticion Fetch:' + error.message);
            });

        if (response.ok) {

            //console.log(response);
            const data = await response.json();

            setBDServer(data);

        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
            console.log(response);
        }
    };

    const ObtenerDatosConexionNube = async () => {

        const response = await fetch("/api/licencia/ObtenerDatosConexionNube/?idLicencia=" + idLicencia, {
            method: 'GET',
            headers:
            {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        })
            .catch((error) => {
                showErrorToast('' + error.message);
                console.log('Hubo un problema con la peticion Fetch:' + error.message);
            });

        if (response.ok) {

            //console.log(response);
            const data = await response.json();

            // if (data.length > 0) {
            /* console.log(data)
                 setDatosNube(data);*/

            /**
             * SPRINT_18
             * Se comenta para que se libere hotfix DESCOMENTAR PARA LIBERAR SPRINT 18
             * */
            //obtenerSucursalesDeEmpresa(idLicencia);
            // }
            //  else
            //     setDatosNube([]);

            setDatosNube(data[0]);

        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
            console.log(response);
        }
    };

    useEffect(() => {
        ObtenerListaServidores();
        ObtenerDatosConexionNube();
    }, []);

    return (
        <>
            <Row className="align-items-center">
                <Col>
                    <h5 className="mb-0">Configuraci&oacute;n Datos Nube</h5>
                </Col>
            </Row>
            <hr></hr>

            {!datosNube ? (
                <div className="text-center p-4">
                    <Spinner animation="border" role="status">
                        <span className="visually-hidden">Cargando...</span>
                    </Spinner>
                </div>
            ) : (
                <Table responsive striped hover size="sm">
                    <tbody>
                        <tr>
                            <td>Identificador</td>
                            <td>
                                <Row>
                                    <Col>
                                        {datosNube?.vIdentificador || 'N/A'}
                                    </Col>
                                    <Col xs="auto">
                                        <CopyButton code={datosNube?.vIdentificador} />
                                    </Col>
                                    {licencias.bIsActive && idCatTipoUsuario == 1 && (
                                        <Col xs="auto">
                                            <IconButton
                                                onClick={() => setEditarIdentificador(true)}
                                                variant="falcon-default"
                                                size="md"
                                                icon="pencil-alt"
                                            />
                                        </Col>
                                    )}
                                </Row>
                            </td>
                        </tr>
                        <tr>
                            <td>Usuario</td>
                            <td>
                                <Row>
                                    <Col>
                                        {datosNube?.vUsuario || 'N/A'}
                                    </Col>
                                    <Col xs="auto">
                                        <CopyButton code={datosNube?.vUsuario} />
                                    </Col>
                                    <Col xs="auto">
                                        <IconButton
                                            onClick={() => setEditarUsuarioNube(true)}
                                            variant="falcon-default"
                                            size="md"
                                            icon="pencil-alt"
                                        />
                                    </Col>
                                </Row>
                            </td>
                        </tr>
                        <tr>
                            <td>Contrase&ntilde;a</td>
                            <td>
                                <Row>
                                    <Col>
                                        {datosNube?.vContrasena || 'N/A'}
                                    </Col>
                                    <Col xs="auto">
                                        <CopyButton code={datosNube?.vContrasena} />
                                    </Col>
                                    <Col xs="auto">
                                        <IconButton
                                            onClick={() => setEditarContrasenaNube(true)}
                                            variant="falcon-default"
                                            size="md"
                                            icon="pencil-alt"
                                        />
                                    </Col>
                                </Row>
                            </td>
                        </tr>
                        <tr>
                            <td>Servidor / BD</td>
                            <td>
                                <Row>
                                    <Col>{datosNube?.vBD || 'N/A'}</Col>
                                    {licencias.bIsActive && idCatTipoUsuario == 1 && (
                                        <Col xs="auto">
                                            <IconButton
                                                onClick={() => setEditarServidorBD(true)}
                                                variant="falcon-default"
                                                size="md"
                                                icon="pencil-alt"
                                            />
                                        </Col>
                                    )}
                                </Row>
                            </td>
                        </tr>
                    </tbody>
                </Table>
            )}

            {/*Modales Configuracion Datos Nube*/}
            {editarIdentificador && datosNube && (
                <Modal
                    show={editarIdentificador}
                    onHide={() => setEditarIdentificador(false)}
                    size="md"
                    backdrop="static"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                >
                    <Modal.Header>
                        <Modal.Title>Editar Identificador. </Modal.Title>
                        <FalconCloseButton className="btn btn-circle btn-sm transition-base p-0" onClick={() => { setEditarIdentificador(false); }} />

                    </Modal.Header>
                    <Modal.Body >
                        <Form noValidate onSubmit={handleSubmit(onSubmitIdentificador)}>
                            <>
                                <Form.Control
                                    type="hidden"
                                    defaultValue={datosNube.idSyncCredenciales}
                                    isInvalid={!!errors.idSyncCredenciales}
                                    {...register("idSyncCredenciales")
                                    }
                                />
                                <Form.Group className="mb-3" >
                                    <Form.Label>Identificador </Form.Label>
                                    <Form.Control
                                        onKeyUp={(event) => { event.target.value = event.target.value.toUpperCase() }}
                                        type="text"
                                        autoComplete="off"
                                        defaultValue={datosNube.vIdentificador}
                                        isInvalid={!!errors.vIdentificador}
                                        {...register("vIdentificador",
                                            {
                                                required: 'El Identificador es requerido',
                                                //pattern: /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/,
                                                maxLength: 36,
                                                minLength: 36
                                            })
                                        }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.vIdentificador && errors.vIdentificador.message}
                                    </Form.Control.Feedback>
                                </Form.Group>

                            </>
                            <Modal.Footer>
                                <Button onClick={() => { setEditarIdentificador(false); }} variant='primary' >Cerrar</Button>
                                {procesandoModal ? <Button variant="primary" disabled>
                                    <Spinner
                                        as="span"
                                        animation="grow"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                    />
                                    Procesando...
                                </Button> : <Button type="submit" variant='success' >Guardar cambios</Button>}
                            </Modal.Footer>
                        </Form>
                    </Modal.Body>
                </Modal>
            )}

            {editarUsuarioNube && datosNube && (
                <Modal
                    show={editarUsuarioNube}
                    onHide={() => setEditarUsuarioNube(false)}
                    size="md"
                    backdrop="static"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                >
                    <Modal.Header>
                        <Modal.Title>Editar Usuario. </Modal.Title>
                        <FalconCloseButton className="btn btn-circle btn-sm transition-base p-0" onClick={() => { setEditarUsuarioNube(false); }} />

                    </Modal.Header>
                    <Modal.Body >
                        <Form noValidate onSubmit={handleSubmit(onSubmitUsuarioNube)}>
                            <>
                                <Form.Control
                                    type="hidden"
                                    defaultValue={datosNube.idSyncCredenciales}
                                    isInvalid={!!errors.idSyncCredenciales}
                                    {...register("idSyncCredenciales")
                                    }
                                />
                                <Form.Group className="mb-3" >
                                    <Form.Label>Usuario</Form.Label>
                                    <Form.Control
                                        type="text"
                                        autoComplete="off"
                                        defaultValue={datosNube.vUsuario}
                                        placeholder="vUsuario"
                                        isInvalid={!!errors.vUsuario}
                                        {...register("vUsuario",
                                            {
                                                required: 'El vUsuario es requerido'
                                            })
                                        }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.vUsuario && errors.vUsuario.message}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </>
                            <Modal.Footer>
                                <Button onClick={() => { setEditarUsuarioNube(false); }} variant='primary' >Cerrar</Button>
                                {procesandoModal ? <Button variant="primary" disabled>
                                    <Spinner
                                        as="span"
                                        animation="grow"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                    />
                                    Procesando...
                                </Button> : <Button type="submit" variant='success' >Guardar cambios</Button>}
                            </Modal.Footer>
                        </Form>
                    </Modal.Body>
                </Modal>
            )}

            {editarContrasenaNube && datosNube && (
                <Modal
                    show={editarContrasenaNube}
                    onHide={() => setEditarContrasenaNube(false)}
                    size="md"
                    backdrop="static"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                >
                    <Modal.Header>
                        <Modal.Title>Editar Contrase&ntilde;a. </Modal.Title>
                        <FalconCloseButton className="btn btn-circle btn-sm transition-base p-0" onClick={() => { setEditarContrasenaNube(false); }} />

                    </Modal.Header>
                    <Modal.Body >
                        <Form noValidate onSubmit={handleSubmit(onSubmitContrasenaNube)}>
                            <>
                                <Form.Control
                                    type="hidden"
                                    defaultValue={datosNube.idSyncCredenciales}
                                    isInvalid={!!errors.idSyncCredenciales}
                                    {...register("idSyncCredenciales")
                                    }
                                />
                                <Form.Group className="mb-3" >
                                    <Form.Label>Contrase&ntilde;a</Form.Label>
                                    <Form.Control
                                        autoComplete="off"
                                        type="text"
                                        defaultValue={datosNube.vContrasena}
                                        placeholder="vContrasena"
                                        isInvalid={!!errors.vContrasena}
                                        {...register("vContrasena",
                                            {
                                                required: 'El vContrasena es requerido'
                                            })
                                        }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.vContrasena && errors.vContrasena.message}
                                    </Form.Control.Feedback>
                                </Form.Group>

                            </>
                            <Modal.Footer>
                                <Button onClick={() => { setEditarContrasenaNube(false); }} variant='primary' >Cerrar</Button>
                                {procesandoModal ? <Button variant="primary" disabled>
                                    <Spinner
                                        as="span"
                                        animation="grow"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                    />
                                    Procesando...
                                </Button> : <Button type="submit" variant='success' >Guardar cambios</Button>}
                            </Modal.Footer>
                        </Form>
                    </Modal.Body>
                </Modal>
            )}

            {editarServidorBD && datosNube && (
                <Modal
                    show={editarServidorBD}
                    onHide={() => setEditarServidorBD(false)}
                    size="md"
                    backdrop="static"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                >
                    <Modal.Header>
                        <Modal.Title>Editar Servidor / BD. </Modal.Title>
                        <FalconCloseButton className="btn btn-circle btn-sm transition-base p-0" onClick={() => { setEditarServidorBD(false); }} />

                    </Modal.Header>
                    <Modal.Body >
                        <Form noValidate onSubmit={handleSubmit(onSubmitServidorBD)}>
                            <>
                                <Form.Control
                                    type="hidden"
                                    defaultValue={datosNube.idSyncCredenciales}
                                    isInvalid={!!errors.idSyncCredenciales}
                                    {...register("idSyncCredenciales")
                                    }
                                />
                                <Form.Group className="mb-3">
                                    <Form.Label>BD / Server</Form.Label>
                                    <Form.Select
                                        aria-label="Default select"
                                        defaultValue={datosNube.vBD}
                                        isInvalid={!!errors.vBD}
                                        {...register("vBD",
                                            {
                                                required: true
                                            })
                                        }
                                    >
                                        <option value="">Selecciona Servidor BD</option>
                                        {BDServer.map((bd, index) => {
                                            return (<option key={index} value={bd.Value}>{bd.Text}</option>)
                                        })}
                                    </Form.Select>
                                </Form.Group>

                            </>
                            <Modal.Footer>
                                <Button onClick={() => { setEditarServidorBD(false); }} variant='primary' >Cerrar</Button>
                                {procesandoModal ? <Button variant="primary" disabled>
                                    <Spinner
                                        as="span"
                                        animation="grow"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                    />
                                    Procesando...
                                </Button> : <Button type="submit" variant='success' >Guardar cambios</Button>}
                            </Modal.Footer>
                        </Form>
                    </Modal.Body>
                </Modal>
            )}
        </>
    )
}

SeccionConfiguracionDatosNube.propTypes = {
    idLicencia: PropTypes.string,
    licencias: PropTypes.object,
    getInformacionDetalladaLicenciaByID: PropTypes.func,
};


export default SeccionConfiguracionDatosNube;